/*
 * NWF-277: top level desktop menu titles are links next to the submenu <details>
 * (snippets/nwf-menu-top-link.liquid). The theme's DetailsDropdown only listens on the
 * <details>, so hover on the link is forwarded to it, and on touch the first tap on the
 * link opens the submenu instead of navigating.
 */
(() => {
    const LINK_SELECTOR = '[data-nwf-menu-link]';

    const getDetails = (link) => link.parentElement?.querySelector(':scope > details[level="top"]');

    const forwardHover = (type) => (event) => {
        const link = event.target instanceof Element && event.target.closest(LINK_SELECTOR);
        if (!link || link.contains(event.relatedTarget)) return;

        getDetails(link)?.dispatchEvent(new MouseEvent(type));
    };

    document.addEventListener('mouseover', forwardHover('mouseenter'));
    document.addEventListener('mouseout', forwardHover('mouseleave'));

    document.addEventListener('click', (event) => {
        if (!window.FoxTheme?.config?.isTouch) return;

        const link = event.target instanceof Element && event.target.closest(LINK_SELECTOR);
        const details = link && getDetails(link);
        if (!details || details.open) return;

        event.preventDefault();
        // After the theme's outside click handlers have closed any other open submenu.
        setTimeout(() => {
            details.open = true;
        });
    });
})();
